export const PageHeaders = {
    vehicle: { header: "Vehicles", sub_header: "Please select an action to start" }
}